import React from 'react';
import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FeatureItemProps } from './types';

const FeatureItem = ({ icon, labelText, description }: FeatureItemProps) => {
  const { t } = useTranslation();

  return (
    <Grid className='feature-item pt-3' size={{ xs: 12 }}>
      <Grid container className='align-items-center d-flex flex-wrap gap-3'>
        <Grid className='align-self-start'>{icon}</Grid>
        <Grid size={{ xs: 8 }}>
          <Typography variant='h6' className='feature-item-title'>
            {t(`featureItems.${labelText}`)}
          </Typography>
          <Typography
            variant='body2'
            sx={{ whiteSpace: 'pre-line' }}
            className='feature-item-description'
          >
            {t(`featureItems.${description}`)}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default FeatureItem;
